module.exports = __webpack_public_path__ + "img/asset8.e2a58d9c.png";